export default __webpack_public_path__ + "static/media/icon_unqualified.95b5d882.svg";